import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios';
import $ from 'jquery';
import Swal from 'sweetalert2';

import Menu from '../main/Menu'
import ElectionAdd from './ElectionAdd';
import { condominiumBoardElectionModelGet } from '../../models/condominiumBoard/elections';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';

import useAuth from '../../controllers/users/useAuth';
import {
    awaitDelay, checkIfUserIsMaster, dataTableLanguaje, buttonProcessGet, globalSettings, processEvaluateGet, responseGet, sendMessageCloseCurrentWindowAsync, badgeStatusGenericSetTwo,
    dateTimeFormatGlobalSet, statusByNumberGet, styles, languageObjGet, isUndNullEmp, LoadingSection
} from '../../helpers/settings';
import BuildingHeader from '../buildings/BuildingHeader';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';

const currentMethod = 'Elections';

const { app, colors, collections: dbColle, icons, images, labels, messages, react, } = globalSettings;
const { backend, } = app;
const { properties: dbProps, } = dbColle;
const { html: reactHtml, firebase, sweetAlert2, } = react;
const { operators: dbOpera, } = firebase;

export default function Elections({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region otehrs
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    const [showLoading, setShowLoading] = useState({ buildings: true, condominiumBoardElections: true, });
    //const [showData, setShowData] = useState(false);
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [processType, setProcessType] = useState(0);
    const [btnAddDisabled, setBtnAddDisabled] = useState(true);
    //#endregion otehrs

    //#region buildings
    const buildingsId = 'buildingsId';
    const [building, setBuilding] = useState(buildingModelGet({}));
    const [buildings, setBuildings] = useState([buildingModelGet({})]);
    //#endregion buildings

    //#region condominum board elections
    let condominiumBoardElections = [];
    const dtCondominiumBoardElectionsId = 'dtcondominiumBoardElections';
    const [condominiumBoardElection, setCondominiumBoardElection] = useState({});
    const [condominiumBoardElectionsShowModal, setCondominiumBoardElectionsShowModal] = useState(false);
    const [dtCondominiumBoradElectionsRowIndex, setDtCondominiumBoradElectionsRowIndex] = useState(0);
    const [btnCondominiumBoardElectionsSyncDisabled, setBtnCondominiumBoardElectionsSyncDisabled] = useState(true);
    //#endregion condominium board elections

    //#region others
    const controls = {
        buttons: {
            // create: {
            //     className: 'btn btn-outline-success float-right btn-sm',
            //     id: 'btnCreate',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            condominiumBoardElections: {
                buttons: {
                    create: {
                        className: 'btn btn-outline-success float-right btn-sm',
                        id: 'btnDtCondominiumBoardElectionsCreate',
                    },
                    delete: {
                        className: 'btn btn-outline-danger float-right btn-sm mx-1',
                        id: 'btnDtCondominiumBoardElectionsDelete',
                    },
                },
                icons: {
                    create: {
                        id: 'iconDtCondominiumBoardElectionsCreate',
                        className: icons?.plusCircle,
                    },
                    delete: {
                        id: 'iconDtCondominiumBoardElectionsDelete',
                        className: icons?.trash,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtCondominiumBoardElectionsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtCondominiumBoardElectionsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    create: {
                        id: 'spDtCondominiumBoardElectionsCreate',
                        className: '',
                    },
                    delete: {
                        id: 'spDtCondominiumBoardElectionsDelete',
                        className: '',
                    },
                },
            },
        },
        icons: {
            // create: {
            //     id: 'iconCreate',
            //     className: icons?.plusCircle,
            // },
        },
        inputs: {
            // email: {
            //     id: 'inputEmail',
            // },
            // password: {
            //     id: 'inputPassword',
            // },
        },
        spinners: {
            // create: {
            //     id: 'spCreate',
            //     className: '',
            // }
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region condominum board elections (methods)
    const dataTableCondominiumBoardElectionsSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTableCondominiumBoardElectionsSet';
        let response = responseGet();
        try {
            $(`#${dtCondominiumBoardElectionsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.date?.[languageObj?.id], width: '0%', searchable: false, visible: false, },
                    { title: labels?.description?.[languageObj?.id], width: '65%', },
                    {
                        render: function (data, type, row) {
                            return badgeStatusGenericSetTwo({
                                type: data,
                                value: statusByNumberGet({
                                    status: data,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result
                            });
                        },
                        title: labels?.status?.[languageObj?.id],
                        width: '10%',
                    },
                    { title: labels?.start?.[languageObj?.id], width: '10%', },
                    { title: labels?.end?.[languageObj?.id], width: '10%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'desc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtCondominiumBoardElectionsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const condominiumBoardElectionsGetAsync = async ({ e, processType_ = 0, subMethod = '', }) => {
        const currentMethod = 'condominiumBoardElectionsGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            processType_ = processType_ === 's' || processType_ === 'b' ? 1 : processType_;

            let idsEditLocal = false;
            let isDeleteLocal = false;
            let buildingLocal = buildingModelGet({});
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            let electionsLocal = [condominiumBoardElectionModelGet({})];

            setBtnAddDisabled(true);
            //#endregion variables

            setShowLoading({ buildings: false, condominiumBoardElections: true, });
            //setShowData(false);

            //#region dataTable clear
            $(`#${dtCondominiumBoardElectionsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            //#endregion dataTable clear

            //#region variables initialize
            setBuilding({});
            setProcessType(processType_);
            condominiumBoardElections = [];
            setBtnCondominiumBoardElectionsSyncDisabled(true);
            //#endregion variables initialize

            //#region old
            // //#region dataTables clear
            // response = localDataTablesClear(true);
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }
            // //#endregion dataTables clear
            //#endregion old

            //#region get condominium board elections
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings?.find(({ id, }) => id === buildingIdLocal);
                if (!isUndNullEmp({ data: buildingLocal, subMethod: currentMethod, })?.result) {
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    dataObj = {
                        conditionals: [
                            { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: `${buildingIdLocal}` }
                        ],
                        ordersBy: [
                            { field: dbProps?.created, value: 'desc', },
                        ],
                        buildingId: buildingIdLocal,
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCondominiumBoardElections}/`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ buildings: false, condominiumBoardElections: false, });
                        //setShowData(false);
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    electionsLocal = response?.result || [];

                    if (!isUndNullEmp({ data: electionsLocal, subMethod: currentMethod, })?.result && electionsLocal?.length > 0) {
                        electionsLocal?.forEach((detail) => {
                            condominiumBoardElections.push([
                                detail?.startDate,
                                detail?.description,
                                detail?.status,
                                dateTimeFormatGlobalSet({
                                    date: detail?.startDate,
                                    type: languageObj?.format?.date?.f1,
                                    //format: languageObj?.format?.time?.type,
                                    format: 0,
                                    addTime: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result,
                                dateTimeFormatGlobalSet({
                                    date: detail?.endDate,
                                    type: languageObj?.format?.date?.f1,
                                    //format: languageObj?.format?.time?.type,
                                    format: 0,
                                    addTime: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result,
                                buttonProcessGet({
                                    id: detail?.id,
                                    description: detail?.description,
                                    showDetails: true,
                                    labelDetails: labels?.detail?.[languageObj?.id],
                                    enabledDetails: true,
                                    showEdit: true,
                                    labelEdit: labels?.edit?.[languageObj?.id],
                                    enabledEdit: processEvaluateGet({
                                        object: detail,
                                        property: labels?.process?.en?.toLowerCase(),
                                        process: labels?.edit?.en?.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    showDelete: true,
                                    labelDelete: labels?.delete?.[languageObj?.id],
                                    enabledDelete: processEvaluateGet({
                                        object: detail,
                                        property: labels?.process?.en?.toLowerCase(),
                                        process: labels?.edit?.en?.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    processButtons: [],
                                    subMethod: currentMethod,
                                })?.result,
                            ]);
                        });

                        //#region check is enebled btnAdd
                        idsEditLocal = processEvaluateGet({
                            object: electionsLocal?.[0],
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.edit?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result;

                        isDeleteLocal = processEvaluateGet({
                            object: electionsLocal?.[0],
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.delete?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result;
                        //#endregion check is enebled btnAdd
                    }

                    //#region check is enebled btnAdd
                    idsEditLocal = processEvaluateGet({
                        object: buildingLocal,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result;

                    isDeleteLocal = idsEditLocal;
                    //#endregion check is enebled btnAdd

                    setBuilding(buildingLocal);
                    setBtnCondominiumBoardElectionsSyncDisabled(false);
                    setBtnAddDisabled(!(idsEditLocal && isDeleteLocal));
                }
            }
            //#endregion get condominium board roles

            //#region dataTable set / data
            //#region old code
            // response = dataTablesSet(true);
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }
            //#endregion old code

            $(`#${dtCondominiumBoardElectionsId}`)?.DataTable()?.rows?.add(condominiumBoardElections)?.draw();
            //#endregion dataTable set / data

            setShowLoading({ buildings: false, condominiumBoardElections: false, });
            //setShowData(true);
        } catch (ex) {
            setShowLoading({ buildings: false, condominiumBoardElections: false, });
            //setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const condominiumBoardElectionsAddEditGetAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, processType_ = 0, subMethod = '', }) => {
        const currentMethod = 'condominiumBoardElectionsAddEditGetAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region variables initialize
            setProcessType(processType_);
            setCondominiumBoardElection({});
            const buildingIdLocal = $(`#${buildingsId}`)?.val();

            //#endregion variables initialize

            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                if (processType_ === 0) {
                    controlsStatusSet({ processType: 1, subMethod: currentMethod, });
                } else {
                    setShowLoading({ building: false, condominiumBoardElections: true, });
                }

                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

                //#region get / set condominium board election
                switch (processType_) {
                    case 0:
                        setCondominiumBoardElection(
                            condominiumBoardElectionModelGet({
                                buildingId: building?.id,
                                userId: auth?.user?.uid,
                            })
                        );
                        break;
                    case 1:
                        window.location.href = `${backend?.urlCondominiumBoardElectionEdit}/${id}`;
                        setShowLoading({ building: false, condominiumBoardElections: false, });
                        return response;
                    case 2:
                        window.location.href = `${backend?.urlCondominiumBoardElectionDetails}/${id}`;
                        setShowLoading({ building: false, condominiumBoardElections: false, });
                        return response;
                    default:
                        break;
                }
                //#endregion get / set condominium board election
            } else {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youMustSelectBuilding?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#region data set
            setProcessType(processType_);
            setDtCondominiumBoradElectionsRowIndex(rowIndex);
            //#endregion data set

            if (processType_ === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, condominiumBoardElections: false, });
            }

            //await awaitDelay(globalSettings?.timers?.threeNanoSeconds);
            setCondominiumBoardElectionsShowModal(true);
        } catch (ex) {
            if (processType_ === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, condominiumBoardElections: false, });
            }
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const localCondominiumBoardElectionsDeleteGet = (id = '', description = '', rowIndex = 0) => {
    //     let response = responseGet();
    //     try {
    //         setDtCondominiumBoradElectionsRowIndex(rowIndex);
    //         setCondominiumBoardElection({});
    //         setCondominiumBoardElection({ ...condominiumBoardElection, id, description, });
    //         $(`#${controls?.dataTables?.condominiumBoardElections?.buttons?.delete?.id}`)?.trigger('click');
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localCondominiumBoardElectionsDeleteGet<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    // }
    //#endregion old code

    //#region old code
    // const localCondominiumBoardElectionDeleteGetAsync = async (e = {}) => {
    //     let response = responseGet();
    //     try {
    //         e.preventDefault();
    //         sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         //#region show alert to delete

    //         let msgText = `${labels?.election?.[languageObj?.id]}: <b>${condominiumBoardElection.description}</b><br/>`;
    //         msgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

    //         const swalProperties = {
    //             icon: sweetAlert2?.icons?.warning,
    //             title: messages?.areYouSureDeleteThis?.[languageObj?.id],
    //             html: msgText,
    //             timer: null,
    //             confirmButtonColor: colors?.warningColorExp,
    //             confirmButtonText: labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: colors?.successColorExp,
    //             cancelButtonText: labels?.no?.[languageObj?.id],
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         const { isConfirmed, } = await Swal.fire(swalProperties);

    //         //#endregion show alert to delete

    //         //#region delete data
    //         if (isConfirmed) {
    //             localCondominiumBoardElectionDeletePostAsync();
    //         }
    //         //#endregion delete data
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localCondominiumBoardElectionDeleteGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    // }
    //#endregion old code

    //#region old code
    // const localCondominiumBoardElectionDeletePostAsync = async () => {
    //     let response = responseGet();
    //     try {
    //         sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         //#region delete condominium board election

    //         headerObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             },
    //         };

    //         //result = await axios.delete(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlCondominiumBoardElections}/${condominiumBoardElection.id}`, headerObj);
    //         result = await axios.delete(`${backend?.url}${backend?.urlApiV1}${backend?.urlCondominiumBoardElections}/${condominiumBoardElection.id}`, headerObj);
    //         response = result.data;

    //         if (!response?.isSuccess || response?.isWarning) {
    //             await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //             return;
    //         }

    //         //#endregion delete condominium board election

    //         //#region delete condominium board election (dataTable)

    //         $(`#${dtCondominiumBoardElectionsId}`)?.DataTable()?.row(dtCondominiumBoradElectionsRowIndex)?.remove()?.draw(true);

    //         //#endregion delete condominium board election (dataTable)

    //         setCondominiumBoardElection({});
    //         setDtCondominiumBoradElectionsRowIndex(0);

    //         sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localCondominiumBoardElectionDeletePostAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    // }
    //#endregion old code

    const condominiumBoardElectionDeleteAsync = async ({ id = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'condominiumBoardElectionDeleteAsync';
        let response = responseGet();
        try {
            //#region show message
            let msgTextObj = {
                one: `${labels?.election?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            let swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: msgTextObj?.one,
                            showConfirmButton: false,
                        });

                        //#region delete condominium board election
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCondominiumBoardElections}/${id}`
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion delete condominium board election

                        //#region delete condominium board election (dataTable)
                        $(`#${dtCondominiumBoardElectionsId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                        //#endregion delete condominium board election (dataTable)

                        setCondominiumBoardElection({});
                        setDtCondominiumBoradElectionsRowIndex(0);

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }
    //#endregion condominum board election (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ buildings: true, condominiumBoardElections: true, });
            //setShowData(false);

            //#region variables initialize
            setBuildings([]);
            condominiumBoardElections = [];
            //#endregion variables initialize

            //#region dataTables set
            response = dataTablesSet({ queryCodeSet_: true, subMethod: currentMethod, });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, condominiumBoardElections: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTables set

            //#region buildings get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlCondominiumBoardElections,
                languageId: languageObj,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, condominiumBoardElections: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings);
            }
            //#endregion buildings get

            setShowLoading({ buildings: false, condominiumBoardElections: false, });
            //setShowData(true);
        } catch (ex) {
            setShowLoading({ buildings: false, condominiumBoardElections: false, });
            //setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSet = ({ queryCodeSet_ = false, subMethod = '', }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            response = dataTableCondominiumBoardElectionsSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            if (queryCodeSet_) {
                response = queryCodeSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region condominiumBoardElections
            $(`#${dtCondominiumBoardElectionsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtCondominiumBoardElectionsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            condominiumBoardElectionsAddEditGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType_: 2, subMethod: currentMethod, });
                            break;
                        case 'edit':
                            condominiumBoardElectionsAddEditGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType_: 1, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            condominiumBoardElectionDeleteAsync({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion condominiumBoardElections
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    //#region old code
    // const localDataTablesClear = (dtCondominiumBoardElectionsClear = false) => {
    //     let response = responseGet();
    //     try {
    //         if (dtCondominiumBoardElectionsClear) {
    //             $(`#${dtCondominiumBoardElectionsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
    //         }
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localDataTablesClear<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.condominiumBoardElections?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.condominiumBoardElections?.buttons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.condominiumBoardElections?.spinners?.create?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.condominiumBoardElections?.icons?.create?.id}`)?.addClass(controls?.dataTables?.condominiumBoardElections?.icons?.create.className);
                    $(`#${controls?.dataTables?.condominiumBoardElections?.buttons?.create?.id}`)?.addClass(controls?.dataTables?.condominiumBoardElections?.buttons?.create?.className);
                    $(`#${controls?.dataTables?.condominiumBoardElections?.spinners?.create?.id}`)?.addClass(controls?.dataTables?.condominiumBoardElections?.spinners?.create.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.condominiumBoardElections?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.condominiumBoardElections?.spinners?.create?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.condominiumBoardElections?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.condominiumBoardElections?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.condominiumBoardElections?.buttons?.create?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu process='condominiumBoardElections' viewName='condominiumBoard' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <section className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.condominiumBoard?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.elections?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {/*buildings*/}
                        <BuildingHeader buildingsId={buildingsId}
                            building={building}
                            buildings={buildings}
                            btnSyncDisabled={btnCondominiumBoardElectionsSyncDisabled}
                            methodGetAsync={condominiumBoardElectionsGetAsync}
                            processType={0}
                            headerSectionValues={{}}
                            showLoading={showLoading?.buildings}
                            languageObj={languageObj} />

                        {/*Elections*/}
                        <div className='row'>
                            <div className='col-12'>
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={reactHtml?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.condominiumBoardElections}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.elections?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.condominiumBoardElections}></img> - {labels?.elections?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                            {/* <button tooltip='tooltip' title={labels?.create?.[languageObj?.id]} className='btn btn-outline-success float-right' onClick={()=> localElevatorAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                {/* {!showLoading ? */}
                                                {/* {<div>} */}
                                                {/* {{showData ?} */}
                                                {/* <div> */}
                                                <button id={controls?.dataTables?.condominiumBoardElections?.buttons?.create?.id}
                                                    className={controls?.dataTables?.condominiumBoardElections?.buttons?.create?.className}
                                                    disabled={isUndNullEmp({ data: building?.id, subMethod: 'btnCreate', })?.result || btnAddDisabled}
                                                    onClick={(e) => condominiumBoardElectionsAddEditGetAsync({ e: e, id: '', description: '', rowIndex: 0, processType_: 0, subMethod: 'btn - addCreate', })}
                                                    tooltip='tooltip'
                                                    title={labels?.add?.[languageObj?.id]}>
                                                    <i id={controls?.dataTables?.condominiumBoardElections?.icons?.create?.id} className={controls?.dataTables?.condominiumBoardElections?.icons?.create?.className} /> <span id={controls?.dataTables?.condominiumBoardElections?.spinners?.create?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                {/* <button id={controls?.dataTables?.condominiumBoardElections?.buttons?.delete?.id}
                                                    className={controls?.dataTables?.condominiumBoardElections?.buttons?.delete?.className}
                                                    disabled={isEmpty(building)}
                                                    hidden
                                                    onClick={(e) => localCondominiumBoardElectionDeleteGetAsync(e)}
                                                    tooltip='tooltip' title={labels?.delete?.[languageObj?.id]}>
                                                    <i id={controls?.dataTables?.condominiumBoardElections?.icons?.delete?.id} className={controls?.dataTables?.condominiumBoardElections?.icons?.delete?.className} /> <span id={controls?.dataTables?.condominiumBoardElections?.spinners?.delete?.id} className='' aria-hidden='true'></span>
                                                </button> */}
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtCondominiumBoardElectionsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                                {/* </div> */}
                                                {/* : <div></div> */}
                                                {/* } */}
                                                {/* {</div>} */}

                                                {/* : */}
                                                {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                        width={40}
                                                        height={40}
                                                        color={colors?.infoColorExp}
                                                        msgText={messages?.processing?.[languageObj?.id]}
                                                        msgOrientation='text-center'
                                                        msgTextMuted={true} /> */}
                                                {/* } */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>{/* /.content*/}

            </div>{/* /.content-wrapper*/}

            {condominiumBoardElectionsShowModal ?
                <ElectionAdd $={$}
                    auth={auth}
                    building={building}
                    condominiumBoardElection={condominiumBoardElection}
                    setCondominiumBoardElection={setCondominiumBoardElection}
                    dtId={dtCondominiumBoardElectionsId}
                    dtRowIndex={dtCondominiumBoradElectionsRowIndex}
                    showModal={condominiumBoardElectionsShowModal}
                    setShowModal={setCondominiumBoardElectionsShowModal}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}